module.exports = __webpack_public_path__ + "img/yanjiufangxiang.6f11d7c4.png";